
const codeGenMetadata: any = {
  formPropertyId: 11,
  formSelector: '[data-name*="consentimento-formulario"]',
  subjectIdentifiers: [
    {
      name: "Telefone",
      selector: ".consentimento-formulario-telefone",
      isPrimary: false,
    },
    {
      name: "Email",
      selector: ".consentimento-formulario-email",
      isPrimary: true,
    },
  ],
  consentIdentifiers: [
    {
      type: "checkbox",
      name: "Aceite de Termos",
      selector: ".consentimento-formulario-termos",
      propertyId: 32,
      consentValue: "checked",
    },
  ],
  consentTrigger: {
    action: "click",
    selector: ".consentimento-formulario-continuar",
  },
};

export default codeGenMetadata;